export const simulateWait = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}
